import {Component, EventEmitter, Input, OnInit, Output, SkipSelf} from '@angular/core';
import {CountryCode} from './country-code';
import {Country} from './country.model';
import {ControlContainer, FormGroup} from '@angular/forms';
import {PhoneValidationIntlService} from './phone-validation-intl.service';
import {Phone} from './phone.model';
import {DynamicFormValidationService} from '../dynamic-forms/dynamic-form-validation.service';
import * as _ from 'underscore';

@Component({
    selector: 'copart-phone-number-intl',
    templateUrl: './phone-number-intl.component.html',
    styleUrls: ['./phone-number-intl.component.scss'],
    providers: [CountryCode]
})
export class PhoneNumberIntlComponent implements OnInit {

  @Input() public groupName: string;
  value = '';

  @Input() phone: Phone;

  @Input() preferredCountries: Array<string> = [];
  @Output() valueChange: EventEmitter<string> = new EventEmitter<string>();

  allCountries: Array<Country> = [];
  preferredCountriesInDropDown: Array<Country> = [];
  selectedCountry: Country = new Country();
  phoneFormGroup: FormGroup;
  PLUS = '+';

  constructor(private countryCodeData: CountryCode, private phoneValidationService: PhoneValidationIntlService,
              @SkipSelf() public parentGroupControl: ControlContainer,private dynamicFormValidationService: DynamicFormValidationService) {
    this.fetchCountryData();
    this.preferredCountries = [];

  }


  ngOnInit() {
    this.buildCountryDropdown();
    this.buildPhoneFormGroup();
    if(!_.isNull(this.phone) &&  !_.isEmpty(this.phone)){
      this.phoneFormGroup.controls.intlDialCode.setValue(this.phone.intlDialCode ? this.phone.intlDialCode :'');
      this.phoneFormGroup.controls.isoTwoCharCntryCode.setValue(this.phone.isoTwoCharCntryCode ? this.phone.isoTwoCharCntryCode :'');
      this.phoneFormGroup.controls.phoneExtension.setValue(this.phone.phoneExtension ? this.phone.phoneExtension :'');
      this.phoneFormGroup.controls.phoneNumber.setValue(this.phone.phoneNumber ? this.phone.phoneNumber : '');
      this.selectedCountry = this.getSelectedCountry(this.phone);
    }
  }
  getSelectedCountry(phone: Phone): Country{
    if(phone){
      const criteriaObj: any = {};
      if(phone.isoTwoCharCntryCode){
        criteriaObj.iso2 = phone.isoTwoCharCntryCode ? phone.isoTwoCharCntryCode.toLowerCase() : phone.isoTwoCharCntryCode;
      }
      if(phone.intlDialCode){
        criteriaObj.dialCode = phone.intlDialCode.toString();
      }
      if(phone.isoTwoCharCntryCode == ''){
        criteriaObj.iso2 = 'us';
      }

      const result = _.find(this.allCountries, criteriaObj) || new Country();
      return Object.assign(new Country(),result);
    }
    return new Country();
  }
  buildCountryDropdown() {
    if (this.preferredCountries.length === 0) {
      this.preferredCountries = ['de', 'fr', 'hu', 'lt', 'pl', 'ru', 'sk'];
    }
    this.preferredCountries.forEach(iso2 => {
      const preferredCountry = this.allCountries.filter((c) => {
        return c.iso2 === iso2;
      });
      this.preferredCountriesInDropDown.push(preferredCountry[0]);
    });

    if (this.preferredCountriesInDropDown.length) {
      this.selectedCountry = Object.assign(new Country(),this.preferredCountriesInDropDown[0]);
    } else {
      this.selectedCountry = Object.assign(new Country(),this.allCountries[0]);
    }
  }

  public onPhoneNumberChange(): void {
    this.value =  this.getFormValue('isoTwoCharCntryCode') + this.getFormValue('intlDialCode') + this.getFormValue('phoneNumber');
    this.valueChange.emit(this.value);
    this.validatePhoneNumber();
  }

  public onCountrySelect(country: Country, el): void {
    this.selectedCountry = country;
    if (this.getFormValue('phoneNumber').length > 0) {
      this.value = this.selectedCountry.dialCode + this.getFormValue('phoneNumber');
      this.valueChange.emit(this.value);
    }
    el.focus();
  }

  public onInputKeyPress(event): void {
    const pattern = /[0-9\+\-\ ]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  getFormValue(name: string){
    let phoneNumber = this.dynamicFormValidationService.getFormControlValue(name,this.phoneFormGroup);
    return phoneNumber ? phoneNumber : '';
  }

  protected fetchCountryData(): void {
    this.countryCodeData.allCountries.forEach(c => {
      const country = new Country();
      country.name = c[0].toString();
      country.iso2 = c[1].toString();
      country.dialCode = c[2].toString();
      country.priority = +c[3] || 0;
      country.areaCode = +c[4] || null;
      country.flagClass = country.iso2.toLocaleLowerCase();
      country.placeHolder = this.getPhoneNumberPlaceHolder(country.dialCode);
      this.allCountries.push(country);
    });
  }

  protected getPhoneNumberPlaceHolder(intlDialCode: string): string {
    const defaultPhoneNumber = '2236512366';
    let formattedPhone = this.phoneValidationService.formatPhoneNumber(defaultPhoneNumber, intlDialCode);
    formattedPhone = formattedPhone.replace(/\s/g, '');

    if (formattedPhone.startsWith(this.PLUS)) {
      return formattedPhone.split(this.PLUS + intlDialCode)[1];
    }
    return formattedPhone;
  }

  /**
   * This builds the form group for address adn appends it to the parent form
   */
  buildPhoneFormGroup() {
    this.phoneFormGroup = this.parentGroupControl.control as FormGroup;
  }

  /**
   * This validates the phone number using the google phone number library
   * @ returns {string}
   */
  isPhoneNumberValid() {
    return this.phoneValidationService.isValidNumber(this.getFormValue('phoneNumber'), this.getFormValue('intlDialCode'));
  }

  /**
   * Validates and adds the errors object
   */
  validatePhoneNumber() {
    let errorObj = null;
    const phoneNumberControl = this.phoneFormGroup.controls['phoneNumber'];
    if (this.phoneFormGroup.controls['phoneNumber'].value !== '') {
      if (!this.isPhoneNumberValid()) {
        errorObj = {invalidNumber: true};
      }
      phoneNumberControl.setErrors(errorObj);
    }

  }
  setPhoneNumber(phoneNumber) {
    this.phoneFormGroup.controls['phoneNumber'].setValue(phoneNumber);
  }

}
